import React, { useEffect } from "react";
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import '../../sass/components/flexibleModules/_components.quicksizerCalModule.scss';
import clumioLogo from '../../images/calc-loader.svg';
import calculatorLogo from '../../images/clumio-logo-calculator.svg';

const QuicksizerCalModule = () => {

    useEffect(() => {
        function myFunction() {
            document.querySelector('.cp-rotator').classList.add('l--show');
            const formEle = document.querySelector("form");
            const formDatab = new FormData(formEle);
            const MacroLink = "https://script.google.com/macros/s/AKfycbxwFkTWCFB6U6a-uU5oD1KWxhC7mE0gF8NXIuoHxtiP8dtSb2MLPBlX--WWFaLMoHZW/exec";

            // post values to gsheet
            fetch(
                MacroLink,
                {
                    method: "POST",
                    body: formDatab
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    console.log(data);
                })
                .catch((error) => {
                    console.log(error);
                });

            // Get result values from Gsheet
            setTimeout(() => {
                fetch(
                    MacroLink,
                    {
                        method: "GET",
                    }
                )
                    .then((res) => res.json())
                    .then((data) => {
                        console.log(data);
                        document.querySelector('.cp-rotator').classList.remove('l--show');
                        // output data to all fields
                        document.querySelector('.l--fieldOne').innerHTML = '$' + Math.round(data[0]['annualawscost']).toLocaleString();
                        document.querySelector('.l--fieldTwo').innerHTML = '$' + Math.round(data[0]['annualclumiocost']).toLocaleString();
                        document.querySelector('.l--fieldThree').innerHTML = '$' + Math.round(data[0]['costsavings']).toLocaleString();
                        document.querySelector('.l--fieldFour').innerHTML = Math.round(data[0]['savings'] * 100) + '%';
                        document.querySelector('.l--fieldFive').innerHTML = data[0]['clumioconfigdata'].replace(/\n/g, "<br />");
                        document.querySelector('.l--fieldSix').innerHTML = data[0]['awsconfigdata'].replace(/\n/g, "<br />");
                        document.querySelector('.l--fieldStatic').innerHTML = data[0]['staticconfigdata'].replace(/\n/g, "<br />");
                        const clumioData = [];
                        const awsData = [];
                        const dataset = data[0];

                        for (var i = 1; i <= 12; i++) {
                            // Construct the property name based on the current index
                            const clumioPropName = `clumio${i}`;
                            const awsPropName = `aws${i}`;

                            // Push the data into the respective arrays after rounding
                            clumioData.push(Math.round(dataset[clumioPropName]));
                            awsData.push(Math.round(dataset[awsPropName]));

                            // Update the HTML elements with the data
                            document.querySelector(`.clumio-${i}`).innerHTML = '$' + dataset[clumioPropName];
                            document.querySelector(`.aws-${i}`).innerHTML = '$' + dataset[awsPropName];
                        }
                        console.log(clumioData)
                        console.log(awsData)

                        myChart.data.datasets[0].data = awsData; // Update Clumio dataset
                        myChart.data.datasets[1].data = clumioData; // Update AWS dataset

                        // Then, update the chart
                        myChart.update();

                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }, 2000);
        }

        const data = {
            labels: ["Month 1", "Month 2", "Month 3", "Month 4", "Month 5", "Month 6", "Month 7", "Month 8", "Month 9", "Month 10", "Month 11", "Month 12"], // X-axis labels
            datasets: [{
                label: 'AWS Pricing',
                data: [], // Your orange category data for each month
                backgroundColor: '#FF9900',
                borderColor: '#FF9900',
                borderWidth: 1
            }, {
                label: 'Clumio Pricing',
                data: [], // Your blue category data for each month
                backgroundColor: '#00DBFF',
                borderColor: '#00DBFF',
                borderWidth: 1
            }]
        };

        document.getElementById("l-quickSizer").addEventListener('submit', function (e) {
            e.preventDefault();
            myFunction();
        });

        Chart.register(ChartDataLabels);
        const ctx = document.getElementById('myChart').getContext('2d');
        const myChart = new Chart(ctx, {
            type: 'bar', // Defines a bar chart
            data: data,
            options: {
                responsive: false,
                maintainAspectRatio: true,
                aspectRatio: 2,
                scales: {
                    y: {
                        beginAtZero: true,
                        ticks: {
                            color: 'white',
                            callback: function (value, index, values) {
                                // Format the number with commas and a dollar sign
                                return new Intl.NumberFormat('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                }).format(value);
                            },
                            font: {
                                size: 14
                            },
                        },
                        title: {
                            display: false,
                        }
                    },
                    x: {
                        ticks: {
                            color: 'white',
                            font: {
                                size: 14
                            },
                        },
                        title: {
                            display: false,
                        },
                    }
                },
                plugins: {
                    title: {
                        display: false,
                    },
                    legend: {
                        display: true,
                        position: 'top',
                        labels: {
                            color: 'white',
                            font: {
                                size: 14
                            },
                            boxWidth: 15,
                            boxHeight: 15
                        }
                    },
                    tooltip: {
                        enabled: false,
                    },
                    datalabels: {
                        color: function (context) {
                            return context.dataset.backgroundColor;
                        },
                        anchor: 'end', // Position the label at the end (top) of the bar
                        align: 'top', // Align label above the bar
                        formatter: function (value, context) {
                            if (value >= 1e6) {
                                return '$' + (value / 1e6).toFixed(1) + 'M'; // Millions
                            } else if (value >= 1e3) {
                                return '$' + (value / 1e3).toFixed(1) + 'k'; // Thousands
                            } else {
                                return '$' + value; // Less than 1000
                            }
                        },
                        font: {
                            size: 14
                        },
                    },
                }
            }
        });
    }, []);

    return (
        <div className="cp-quicksizerSection">
            <div className="cp-quicksizerSection__inner">
                <div className="cp-calculatorwrapper" id="l--calcWrap">
                    <div className="cp-calculatorwrapper__inner">
                        <div className="cp-rotator">
                            <img src={clumioLogo} alt="Clumio" />
                        </div>
                        <div className="cp-calculatorwrapper__metrics">
                            <div className="cp-calculatorwrapper__metrics-top l--flex">
                                <img src={calculatorLogo} alt="" />
                                <form id="l-quickSizer" className="l--flex">
                                    <div>
                                        <label for="products">Product</label>
                                        <select name="products" id="products">
                                            <option value="">----</option>
                                            <option value="Aurora">Aurora</option>
                                            <option value="DynamoDB">DynamoDB</option>
                                            <option value="EC2/EBS">EC2/EBS</option>
                                            <option value="RDS">RDS</option>
                                            <option value="S3">S3</option>
                                            <option value="SQL on EC2">SQL on EC2</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label for="size">Size (TB)</label>
                                        <input type="number" id="size" name="size" placeholder="add size" />
                                    </div>
                                    <input className="l-button" type="submit" value="Calculate" />
                                </form>
                            </div>
                            <div className="cp-calculatorwrapper__metrics-bottom l--flex">
                                <div>
                                    <span>Annual AWS Cost (USD)</span>
                                    <span className="l--fieldOne">----</span>
                                </div>
                                <div>
                                    <span>Annual Clumio Cost (USD)</span>
                                    <span className="l--fieldTwo">----</span>
                                </div>
                                <div>
                                    <span>Cost Savings (USD)</span>
                                    <span className="l--fieldThree">----</span>
                                </div>
                                <div>
                                    <span>Savings</span>
                                    <span className="l--fieldFour">----</span>
                                </div>
                            </div>
                        </div>
                        <div className="cp-calculatorwrapper__graph">
                            <h2>Clumio vs AWS backups TCO</h2>
                            <div className="l--graph">
                                <canvas id="myChart"></canvas>
                            </div>
                            <ul className="l--visibilityHid">Clumio pricing:
                                <li><span>month 1:</span><span className="clumio-1"></span></li>
                                <li><span>month 2:</span><span className="clumio-2"></span></li>
                                <li><span>month 3:</span><span className="clumio-3"></span></li>
                                <li><span>month 4:</span><span className="clumio-4"></span></li>
                                <li><span>month 5:</span><span className="clumio-5"></span></li>
                                <li><span>month 6:</span><span className="clumio-6"></span></li>
                                <li><span>month 7:</span><span className="clumio-7"></span></li>
                                <li><span>month 8:</span><span className="clumio-8"></span></li>
                                <li><span>month 9:</span><span className="clumio-9"></span></li>
                                <li><span>month 10:</span><span className="clumio-10"></span></li>
                                <li><span>month 11:</span><span className="clumio-11"></span></li>
                                <li><span>month 12:</span><span className="clumio-12"></span></li>
                            </ul>
                            <ul className="l--visibilityHid">AWS pricing:
                                <li><span>month 1:</span><span className="aws-1"></span></li>
                                <li><span>month 2:</span><span className="aws-2"></span></li>
                                <li><span>month 3:</span><span className="aws-3"></span></li>
                                <li><span>month 4:</span><span className="aws-4"></span></li>
                                <li><span>month 5:</span><span className="aws-5"></span></li>
                                <li><span>month 6:</span><span className="aws-6"></span></li>
                                <li><span>month 7:</span><span className="aws-7"></span></li>
                                <li><span>month 8:</span><span className="aws-8"></span></li>
                                <li><span>month 9:</span><span className="aws-9"></span></li>
                                <li><span>month 10:</span><span className="aws-10"></span></li>
                                <li><span>month 11:</span><span className="aws-11"></span></li>
                                <li><span>month 12:</span><span className="aws-12"></span></li>
                            </ul>
                        </div>
                        <div className="cp-calculatorwrapper__content">
                            <div className="l--flex">
                                <div className="cp-calculatorwrapper__content-clumiobackupconfig">
                                    <h2>Clumio backup configuration</h2>
                                    <div className="l--fieldFive">
                                        ----
                                    </div>
                                </div>
                                <div className="cp-calculatorwrapper__content-awsbackupconfig">
                                    <h2>AWS backup configuration</h2>
                                    <div className="l--fieldSix">
                                        ----
                                    </div>
                                </div>
                            </div> 
                            <div className="cp-calculatorwrapper__content-notes">
                                <h3>Notes:</h3>
                                <div className="l--fieldStatic">
                                    {/* <li>Clumio and AWS Backup pricing for US West (Oregon)/us-west-2 region are used.</li>
                                    <li>Pricing is shown for the first year after onboarding.</li>
                                    <li>Calculations assume change rates of 2% every 12 hours, 4% every day, 10% every week and 20% every month in case for incremental backups.</li> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default QuicksizerCalModule;